module.exports = __webpack_public_path__ + "images/[3]Premium_8_eme_6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[3]Premium_8_eme_6.jpg
// module id = 35
// module chunks = 0